import { RoomDetailComponent } from './../room-detail/room-detail.component';
import { Room } from './../shared/models/rooms.model';
import { RoomsService } from '../shared/services/rooms.service';
import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rooms',
  templateUrl: './rooms.component.html',
  styleUrls: ['./rooms.component.scss']
})
export class RoomsComponent implements OnInit {

  rooms: Room[];
  langSelected: string;
  closeResult: string;

  constructor(private roomsService: RoomsService,
    private modalService: NgbModal) { }

  ngOnInit() {
    this.langSelected = localStorage.getItem("langSelected");
    this.rooms = JSON.parse(sessionStorage.getItem('roomsData'));
    if(this.rooms == null){
      this.roomsService.getRooms(this.langSelected)
      .subscribe((rooms: any) => {
        sessionStorage.setItem('roomsData', JSON.stringify(rooms));
        this.rooms = rooms;
      });
    }
  }

  open(content, roomId) {
    const modalRef = this.modalService.open(RoomDetailComponent, { windowClass: 'customModalRoom' });
    modalRef.componentInstance.roomId = roomId;
  }

}
